"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdentityService = void 0;
var rest_service_1 = require("./rest.service");
var enums_1 = require("../shared/enums");
var auth_service_1 = require("./auth.service");
/**
 * Class declaration
 */
var IdentityService = /** @class */ (function (_super) {
    __extends(IdentityService, _super);
    /**
     * constructor
     */
    function IdentityService(brandService) {
        var _this = this;
        var authServiceInstance = new auth_service_1.AuthService();
        _this = _super.call(this, {
            serviceName: enums_1.ServicesEnum.IDENTITY,
            baseURL: brandService.config.identityServiceUrl,
            authService: authServiceInstance,
        }) || this;
        _this.launchesResource = 'launches';
        _this.usersResource = 'users';
        _this.authService = authServiceInstance;
        _this.baseURL = brandService.config.identityServiceUrl;
        _this.lmsURL = brandService.config.consumerLMSUrl;
        _this.enrollmentUIUrl = brandService.config.enrollmentUrl;
        return _this;
    }
    /**
     * createLaunchId() - Creates a short-lived launchID that can be redeemed for a JWT token later
     */
    IdentityService.prototype.createLaunchId = function () {
        var userId = this.authService.userId;
        var schoolId = this.authService.schoolId;
        var role = this.authService.role;
        if (userId !== null && schoolId !== null && role !== null) {
            var body = {
                userId: Number(userId),
                schoolId: Number(schoolId),
                role: role,
            };
            return this.update(this.launchesResource, body)
                .then(function (response) {
                return response.data;
            })
                .catch(function (rejectReason) {
                return Promise.reject(new Error('Error while creating a new launch id -> ' + rejectReason));
            });
        }
        else {
            return Promise.reject(new Error('Unable create LaunchID due to invalid userId and/or schoolId in JWT token'));
        }
    };
    /**
     * fetchLaunchLocationLMS - Fetch the launch url for the Consumer LMS legacy app
     */
    IdentityService.prototype.fetchLaunchLocationLMS = function () {
        var _this = this;
        return this.createLaunchId()
            .then(function (launchData) {
            return _this.lmsURL + '/issuer_launches/' + launchData.id;
        })
            .catch(function (rejectReason) {
            return Promise.reject(new Error('Unable to fetch LMS launch location -> ' + rejectReason));
        });
    };
    /**
     * fetchLaunchLocationEnrollment - Fetch the launch url for the Enrollment UI
     */
    IdentityService.prototype.fetchLaunchLocationEnrollment = function () {
        var _this = this;
        return this.createLaunchId()
            .then(function (launchData) {
            return _this.enrollmentUIUrl + '/launches/' + launchData.id;
        })
            .catch(function (rejectReason) {
            return Promise.reject(new Error('Unable to fetch Enrollment UI launch location -> ' + rejectReason));
        });
    };
    /**
     * showLaunchID
     *
     * @param id
     */
    IdentityService.prototype.showLaunchId = function (id) {
        return this.show(this.launchesResource, id)
            .then(function (response) {
            return response.data;
        })
            .catch(function (rejectReason) {
            return Promise.reject(new Error('Unable to show LaunchID -> ' + rejectReason));
        });
    };
    /**
     * searchUsers - search for a list of user using the stored JWT and query params.
     *
     * @param userQueryParams
     */
    IdentityService.prototype.searchUsers = function (userQueryParams) {
        return this.search(this.usersResource, userQueryParams, true)
            .then(function (response) {
            return response.data;
        })
            .catch(function (rejectReason) {
            return Promise.reject(new Error('Unable to search users -> ' + rejectReason));
        });
    };
    IdentityService.prototype.searchActiveStudents = function () {
        var schoolId = this.authService.schoolId;
        if (schoolId === null) {
            return Promise.reject(new Error('Unable to determine schoolId when searching for active students'));
        }
        var userQueryParms = {
            schoolId: schoolId,
            role: enums_1.IdentityRolesEnum.STUDENT,
            status: enums_1.IdentityStatusEnum.ACTIVE,
        };
        return this.searchUsers(userQueryParms).catch(function (rejectReason) {
            return Promise.reject(new Error('Unable to search active students -> ' + rejectReason));
        });
    };
    return IdentityService;
}(rest_service_1.RestService));
exports.IdentityService = IdentityService;
